import { fastExpLanguageConfiguration, fastExpLanguageDefinition } from '../../components/Editor/CodeEditor/lib/fastExpressionDefinition';

interface EditorWillMountProps {
  expressionOperators: any;
  fastExpressionOperators: any;
  languageFieldsRegularIds: string[];
  languageFieldsSelectionIds: string[];
  languageFieldsComboIds: string[];
}

export function registerMonacoLanguage(monaco: any, languageId: string) {
  if (!monaco.languages.getLanguages()?.find((language: { id?: string }) => language?.id === languageId)) {
    monaco.languages.register({ id: languageId });
    monaco.languages.setLanguageConfiguration(languageId, fastExpLanguageConfiguration());
  }
}

export const editorWillMountMonaco =
  ({ fastExpressionOperators, languageFieldsRegularIds, languageFieldsSelectionIds, languageFieldsComboIds }: EditorWillMountProps) =>
  () => {
    import('react-monaco-editor')
      .then(({ monaco }) => {
        const fieldsRegularIds = languageFieldsRegularIds;
        const fieldsSelectionIds = languageFieldsSelectionIds;
        const fieldsComboIds = languageFieldsComboIds;

        const fastExpressionOperatorsArray = fastExpressionOperators ? fastExpressionOperators.toJS() : [];

        const fieldIdsMap: any = {
          regular: fieldsRegularIds,
          selection: fieldsSelectionIds,
          combo: fieldsComboIds,
        };

        ['regular', 'selection', 'combo'].map((type: string) => {
          // Set fast expression code for regular, selection and combo

          const languageId = `fastexpr-${type}`;
          registerMonacoLanguage(monaco, languageId);

          const definition = fastExpLanguageDefinition(
            fastExpressionOperatorsArray[type] ? fastExpressionOperatorsArray[type] : [],
            fieldIdsMap[type]
          );
          monaco.languages.setMonarchTokensProvider(languageId, definition);
        });
      })
      .catch(error => 'An error occured while loading react-monaco-editor');
  };
